import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
	components: {}
})
export default class MatIcon extends Vue {
	@Prop()
	public readonly type!: string;
}
